module.exports = __webpack_public_path__ + "static/img/bride_app_qrcode.b8cd11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bride_app_qrcode.png
// module id = 301
// module chunks = 1